<template>
  <div class="login-page">
    <PageSpinner :onloader="onloader" />
    <a href="https://schooldock.com/" class="goback-btn" aria-label="Return to home page">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <span>Home</span>
    </a>
    <main class="login-card">
      <div class="login-header">
        <h1 class="login-title">Welcome Back</h1>
        <p class="login-subtitle">Sign in to your account to continue</p>
      </div>
     
      <form role="form" @submit.prevent="userlogin">
        <div class="form-group">
          <label class="form-label" for="username">Username</label>
          <input type="text" id="username" class="form-input" v-model="username" placeholder="Enter your username"
            required>
        </div>

        <div class="form-group">
          <label class="form-label" for="password">Password</label>
          <div class="password-field">
            <input :type="showPassword ? 'text' : 'password'" id="password" class="form-input password-input"
              v-model="password" placeholder="Enter your password" autocomplete="current-password" required>
            <button type="button" class="password-toggle" @mousedown.prevent @click="showPassword = !showPassword"
              :aria-label="showPassword ? 'Hide password' : 'Show password'" :aria-pressed="showPassword">
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="remember-forgot">
          <div class="remember-me">
            <input type="checkbox" id="remember" v-model="rememberMe">
            <label for="remember">Remember me</label>
          </div>          
          <router-link to="/retrieve-password" class="forgot-password"><small class="pl-3">Forgot
              password?</small></router-link>
        </div>
        <div>
          <button type="submit" class="btn login-button" :disabled="$store.state.appdatas.disenableifNotOnline">
            Sign in <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </form>
      <div class="mt-2 text-center">
        <p class="text-sm text-gray-600">
          Ready to modernize your institution?
          <span class="block mt-1">
            <router-link to="/school-registration" class="font-bold text-indigo-600 hover:text-indigo-500 hover:underline">
              Onboard your school today &rarr;
            </router-link>
          </span>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import PageSpinner from "@/components/PageSpinner"
import RandomWord from "@/mixins/random-word-generator.mixin"
import Alert from "@/mixins/Alert.mixins"
export default {
  name: "login",
  components: { PageSpinner },
  mixins: [RandomWord, Alert],
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rememberMe: false,
      errormsg: "",
      onloader: "none",
    };
  },
  methods: {
    userlogin() {
      let username = `${this.RandomStringNumber(30)}${process.env.VUE_APP_ENV_USPAD}${btoa(this.username)}`;
      let password = `${this.RandomStringNumber(30)}${process.env.VUE_APP_ENV_PWDPAD}${btoa(this.password)}`;

      this.onloader = "flex";
      let payload = {
        username,
        password
      };
      this.$store
        .dispatch("auth/Auth", payload)
        .then((resp) => {
          if (resp.responseCode == '00') {
            var accessDetails = resp.data.data;
            this.$store.dispatch("auth/MutateUsername", accessDetails.userName);
            this.onloader = "none";
            if (accessDetails.isDefaultPasswordChanged == false) {
              this.$router.push("/change-password");
            } else {
              if (accessDetails.isSchoolStaff) {
                this.GetLoginStaffDetails();
              } else {
                this.navigateAfterLogin();
              }

            }

          } else {
            this.onloader = "none";
            this.ShowAlertError(resp.responseMessage, '');
          }
        })
        .catch((err) => {
          this.password = "";
          this.onloader = "none";
          const errorMessage = err && err.response && err.response.data;
          if (errorMessage === "Yet to Logon") {
            this.$router.push("/change-password");
          } else {
            this.ShowAlertError(errorMessage || (err && err.message) || "Unable to sign in. Please try again.", '');
          }
        });
    },
    getbank() {
      this.onloader = "flex";
      this.$store
        .dispatch("getbank")
        .then(() => {
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    getschooltypes() {
      this.onloader = "flex";
      this.$store
        .dispatch("getschooltypes")
        .then(() => {
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    getstate() {
      this.onloader = "flex";
      this.$store
        .dispatch("getstates")
        .then(() => {
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    getprivacypolicy() {
      this.onloader = "flex";
      this.$store
        .dispatch("getprivacypolicy")
        .then(() => {
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    getstaffdetails() {
      this.onloader = "flex";
      this.$store
        .dispatch("getstaffdetails")
        .then(() => {
          this.onloader = "none";
          this.navigateAfterLogin();
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    getreportrequest() {
      let passcode = this.$route.query.rep;
      if (passcode != null || passcode != undefined) {
        this.onloader = "flex";
        this.$store
          .dispatch("passcodeaccess", passcode)
          .then((resp) => {
            this.onloader = "none";
            if (resp.ReportType == "Full") {
              this.$router.push("/studreportcard?rep=" + passcode);
            }
            if (resp.ReportType == "Mid") {
              this.$router.push("/studreportcardmid?rep=" + passcode);
            }
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, '');
          });
      }
    },
    GetUserStatus() {
      this.onloader = "flex";
      this.$store
        .dispatch("GetUserStatus")
        .then(() => {
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          console.log(err);
        });
    },
    GetLoginStaffDetails() {
      this.onloader = "flex";
      this.$store
        .dispatch("SchoolStaff/GetLoginStaffDetails")
        .then(() => {
          this.$router.push("/dashboard");
          this.onloader = "none";
        })
        .catch((err) => {
          console.log(err);
          this.onloader = "none";
        });
    },
    navigateAfterLogin() {
      const redirect = this.$route.query.redirect;
      if (typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//") && !redirect.includes("\\")) {
        const matched = this.$router.match(redirect);
        const isProtectedRoute = matched.matched.some(
          (record) => record.meta && record.meta.user
        );
        if (isProtectedRoute && matched.name !== "Login") {
          this.$router.replace(redirect).catch(() => {});
          return;
        }
      }
      this.$router.replace("/dashboard").catch(() => {});
    },
  },
  mounted() {
    this.getprivacypolicy();
    this.getstate();
    this.GetUserStatus();
    this.getbank();
    this.getschooltypes();
    this.getreportrequest();
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  padding: 2.75rem 0 1rem;
}

.login-card {
  width: 100%;
  max-width: 27rem;
  margin: auto;
}

.login-header {
  margin-bottom: 2rem;
}

.login-title {
  font-size: clamp(1.75rem, 4vw, 2.1rem);
  font-weight: 700;
  color: #172b4d;
  margin-bottom: 0.45rem;
  letter-spacing: -0.035em;
}

.login-subtitle {
  color: #68788d;
  font-size: 0.95rem;
  margin-bottom: 0;
}

.form-group {
  margin-bottom: 1.2rem;
}

.form-label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #344563;
}

.form-input {
  width: 100%;
  min-height: 3.1rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid #d6deea;
  border-radius: 0.65rem;
  background-color: #fff;
  color: #172b4d;
  font-size: 16px;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-input:focus {
  border-color: #2d6fae;
  box-shadow: 0 0 0 3px rgba(45, 111, 174, 0.14);
  outline: none;
}

.password-field {
  position: relative;
}

.password-input {
  padding-right: 3.2rem;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0.45rem;
  display: inline-flex;
  width: 2.4rem;
  height: 2.4rem;
  align-items: center;
  justify-content: center;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: #708198;
  cursor: pointer;
}

.password-toggle:hover {
  background: #f1f5fa;
  color: #1850b8;
}

.password-toggle:focus-visible {
  outline: 2px solid #2d6fae;
  outline-offset: 1px;
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.35rem;
  gap: 0.75rem;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 2.75rem;
  color: #52647a;
  font-size: 0.85rem;
}

.remember-me input {
  width: 1rem;
  height: 1rem;
  accent-color: #1850b8;
}

.forgot-password {
  color: #1850b8;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
}

.forgot-password:hover {
  text-decoration: underline;
}

.login-button {
  width: 100%;
  min-height: 3.15rem;
  padding: 0.8rem 1rem;
  background: linear-gradient(110deg, #1850b8 0%, #2d6fae 100%);
  color: white;
  border: none;
  border-radius: 0.65rem;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 160ms ease, background-color 160ms ease;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 7px 18px rgba(24, 80, 184, 0.24);
}

.login-button:disabled {
  opacity: 0.62;
  cursor: not-allowed;
}

.goback-btn {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 2.65rem;
  padding: 0.5rem 0.8rem;
  background: #fff;
  color: #52647a;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  box-shadow: 0 2px 8px rgba(15, 35, 65, 0.05);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  transition: color 160ms ease, border-color 160ms ease, background-color 160ms ease;
}

.goback-btn:hover {
  background: #f7f9fc;
  color: #1850b8;
  border-color: #c8d7ea;
}

.goback-btn:focus-visible {
  outline: 2px solid #2d6fae;
  outline-offset: 2px;
}

.alert {
  overflow-wrap: anywhere;
  border-radius: 0.65rem;
  font-size: 0.85rem;
  line-height: 1.5;
}

@media (max-width: 575.98px) {
  .login-page {
    align-items: flex-start;
    padding: 3.5rem 0 0.75rem;
  }

  .login-header {
    margin-bottom: 1.5rem;
  }

  .goback-btn {
    left: 0;
    top: 0;
  }
}

@media (max-height: 520px) and (orientation: landscape) {
  .login-page {
    align-items: flex-start;
    padding-top: 3.25rem;
  }
}
</style>
